import { DeviceExtractionStateType } from './state'

export interface DeviceExtractionGettersType {
  getDeviceExtractionById: (state: DeviceExtractionStateType, id: string) => DeviceExtractionStateType['deviceExtraction']
  getDeviceExtractionsByDeviceSettingId: (state: DeviceExtractionStateType, deviceSettingId: string) => DeviceExtractionStateType['deviceExtractions']
  getDeviceExtractionsByType: (state: DeviceExtractionStateType, type: string) => DeviceExtractionStateType['deviceExtractions']
  getActiveDeviceExtractions: (state: DeviceExtractionStateType) => DeviceExtractionStateType['deviceExtractions']
  getOverdueDeviceExtractions: (state: DeviceExtractionStateType) => DeviceExtractionStateType['deviceExtractions']
  getDeviceExtractionsByPollingInterval: (state: DeviceExtractionStateType, interval: number) => DeviceExtractionStateType['deviceExtractions']
}

export const DeviceExtractionGetters = {
  getDeviceExtractionById: (state: DeviceExtractionStateType) => (id: string) => {
    return state.deviceExtractions.find(deviceExtraction => deviceExtraction.id === id)
  },
  getDeviceExtractionsByDeviceSettingId: (state: DeviceExtractionStateType) => (deviceSettingId: string) => {
    return state.deviceExtractions.filter(deviceExtraction => deviceExtraction.deviceSettingId === deviceSettingId)
  },
  getDeviceExtractionsByType: (state: DeviceExtractionStateType) => (type: string) => {
    return state.deviceExtractions.filter(deviceExtraction => deviceExtraction.type === type)
  },
  getActiveDeviceExtractions: (state: DeviceExtractionStateType) => {
    return state.deviceExtractions.filter(deviceExtraction => deviceExtraction.active)
  },
  getOverdueDeviceExtractions: (state: DeviceExtractionStateType) => {
    return state.deviceExtractions.filter(deviceExtraction => deviceExtraction.isOverdue())
  },
  getDeviceExtractionsByPollingInterval: (state: DeviceExtractionStateType) => (interval: number) => {
    return state.deviceExtractions.filter(deviceExtraction => deviceExtraction.pollingInterval === interval)
  },
}
